'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var ui = require('../../button/v2/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const LoadMoreButton = ({ loading, isEmpty, hasMore, loadMore }) => {
  if (!loading && !isEmpty) {
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, {
      children: hasMore ? /* @__PURE__ */ jsxRuntime.jsx(ui.ButtonV2, {
        text: "Xem th\xEAm",
        onClick: loadMore,
        buttonStyle: {
          background: "white",
          hover: {
            color: "#777777"
          },
          border: {
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: "#d9d9d9",
            borderRadius: 4
          },
          padding: { bottom: 8, top: 8, left: 16, right: 16 },
          margin: { top: 16, bottom: 16 }
        },
        commonStyle: { justifyContent: "center" }
      }) : /* @__PURE__ */ jsxRuntime.jsx(ArticleListFooter, {
        children: "Kh\xF4ng c\xF2n b\xE0i vi\u1EBFt n\xE0o"
      })
    });
  } else
    return null;
};
const ArticleListFooter = styled__default["default"].div`
  text-align: center;
  margin: 2em 0;
  color: gray;
`;

exports.LoadMoreButton = LoadMoreButton;
